import { useTranslation } from 'react-i18next';

export type VideoProps = {
  url: string;
  width: number;
  height: number;
  className?: string;
};

export const Video = ({ width, height, url, className }: VideoProps) => {
  const { t } = useTranslation();

  return (
    <video
      controls
      className={className}
      style={{ height: `${height}px`, width: `${width}px`, minWidth: `${width}px`, minHeight: `${height}px` }}
    >
      <source src={url} type='video/mp4' />
      <source src={url} type='video/webm' />
      <source src={url} type='video/ogg' />
      {t('global.videoNotSupported')}
      <track kind='captions' />
    </video>
  );
};
